<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content with-footer">
        <el-form
          ref="productForm"
          :model="product"
          label-width="80px"
          size="small"
          class="box"
        >
          <fieldset class="mgb15">
            <legend>
              {{ $t("text.baseInfo") }}
            </legend>
            <el-row>
              <el-col :span="8">
                <el-form-item
                  :label="$t('product.productNo')"
                  :prop="'productNo'"
                  :rules="[
                    {
                      required: true,
                      validator: validateProductNo,
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input size="small" v-model.trim="product.productNo" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('product.name')" :prop="'name'">
                  <el-input size="small" v-model.trim="product.name" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('product.category')"
                  :prop="'categoryId'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('product.category')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-select
                    size="small"
                    v-model="product.categoryId"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="category in categories"
                      :key="category.id"
                      :label="category.name"
                      :value="category.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item
                  :label="$t('product.unit')"
                  :prop="'unit'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('product.unit')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-select
                    size="small"
                    v-model="product.unit"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="unit in units"
                      :key="unit.id"
                      :label="unit.name"
                      :value="unit.name"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('text.price')"
                  :prop="'rentPrice'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('text.price')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input size="small" v-model.trim="product.rentPrice" />
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <el-row :gutter="10">
            <el-col :span="9">
              <fieldset class="mgb15">
                <legend>
                  {{ $t("product.images") }}
                  <svg-icon icon-class="link" @click="linkImage" />
                </legend>
                <dropzone v-model="product.images" multiple />
              </fieldset>
            </el-col>
            <el-col :span="15">
              <fieldset class="mgb15">
                <legend>{{ $t("product.introduction") }}</legend>
                <el-input
                  v-model="product.introduction"
                  type="textarea"
                  :rows="2"
                />
              </fieldset>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="drawer-footer">
      <el-button
        type="primary"
        size="small"
        plain
        :loading="saveDoing"
        @click="saveSubmit"
        >{{ $t("text.submit") }}</el-button
      >
    </div>
    <el-dialog
      :append-to-body="true"
      :title="$t('action.linkImage')"
      :visible.sync="linkImageDF"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-form ref="linkImageObjForm" :model="linkImageObj">
        <el-form-item
          :prop="'linkImageStr'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('action.linkImage')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="linkImageObj.linkImageStr"
            :placeholder="$t('prompt.linkImageExplain')"
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 10 }"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="linkImageDoing"
          size="small"
          @click="linkImageSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="linkImageDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import TinymceEditor from "@/components/TinymceEditor";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";

import Dropzone from "@/components/Dropzone";
import Product from "@/api/product.js";
import Category from "@/api/category.js";
import Unit from "@/api/unit";

export default {
  props: {
    id: null,
  },
  mixins: [page],
  components: {
    TinymceEditor,
    Dropzone,
    RawHtmlLimitNumber,
  },
  data() {
    var validateProductNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("product.productNo")]))
        );
        return;
      }
      Product.findByProductNo({ productNo: value }).then(function (res) {
        if (res.data.code === 200 && res.data.entity.id !== self.product.id) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("product.productNo")]))
          );
        } else {
          callback();
        }
      });
    };
    return {
      Util: Util,
      validateProductNo: validateProductNo,
      product: {},

      saveDoing: false,

      categories: [],
      units: [],

      // 图片链接
      linkImageDF: false,
      linkImageObj: {
        linkImageStr: null,
      },
      linkImageDoing: false,
    };
  },

  computed: {},
  created() {
    const self = this;
    self.loadingStart();
    axios
      .all([
        Product.findById(self.id),
        Category.serviceCategory(),
        Unit.findByTenantId(),
      ])
      .then(
        axios.spread(function (product, categories, units) {
          if (product.data.code === 200) {
            self.product = product.data.entity;
          } else {
            self.sysError();
          }
          if (categories.status === 200) {
            self.categories = categories.data;
          } else {
            self.sysError();
          }

          if (units.status === 200) {
            self.units = units.data;
          } else {
            self.sysError();
          }

          self.loadingEnd();
        })
      );
  },
  methods: {
    // 图片链接
    linkImage() {
      this.linkImageDF = true;
      this.linkImageObj.linkImageStr = null;
    },
    linkImageSubmit() {
      const self = this;
      self.$refs.linkImageObjForm.validate((valid) => {
        if (valid) {
          const linkImageArr = this.linkImageObj.linkImageStr.split("\n");
          const linkImageArrFilter = linkImageArr.filter((a) => a != null);
          if (self.product.images == null) {
            self.product.images = linkImageArrFilter.join(";");
          } else {
            self.product.images =
              self.product.images + ";" + linkImageArrFilter.join(";");
          }
          self.linkImageDF = false;
        } else {
          return false;
        }
      });
    },
    saveSubmit() {
      const self = this;
      this.$refs.productForm.validate((valid) => {
        if (valid) {
          if (self.regexSizePriceDF(self.product)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("text.price")]),
              type: "warning",
            });
            return;
          }
          self.editDoing = true;
          Product.update(self.product.id, self.product).then(function (res) {
            self.editDoing = false;
            self.asyncInvDF = false;
            if (res.status === 200) {
              self.$eventHub.$emit("productUpdate");
              self.sysResult(res.data, self.$t("prompt.editSuccess"));
              self.$emit("updateInfo");
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    regexSizePriceDF(obj) {
      const self = this;
      if (
        obj.rentPrice != null &&
        obj.rentPrice != "" &&
        !Util.regexPrice(obj.rentPrice)
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>